<template>
  <q-card>
    <q-card-section class="no-padding">
      <q-chip square color="indigo" text-color="white" label="تعداد اقلام" v-if="localItems">
        <q-badge color="red" text-color="white" :label="localItems.length"/>
      </q-chip>
      <q-chip square color="indigo" text-color="white" label="جمع اقلام" v-if="localItems">
        <q-badge color="red" text-color="white"
                 :label="lodash.sumBy(localItems, item=> parseFloat(item.selectedCount))"/>
      </q-chip>
      <q-chip square color="indigo" text-color="white" label="تعداد کارتن" v-if="localItems">
        <q-badge color="red" text-color="white"
                 :label="Math.round(lodash.sumBy(localItems.filter(rec=> rec.Goods_Box), item=> parseInt(item.selectedCount)/item.Goods_Box)).toLocaleString()"/>
      </q-chip>
      <q-chip square color="indigo" text-color="white" label="مبلغ سفارش" v-if="localItems && !isBuyRequest">
        <q-badge color="red" text-color="white"
                 :label="lodash.sumBy(localItems, item=> parseInt(item.selectedCount)  * parseInt(item.BuyLast_Price)).toLocaleString()"/>
      </q-chip>
    </q-card-section>
    <q-card-section class="no-padding text-right">
      <q-chip square clickable icon="done_all"
              label="ثبت بر اساس نقطه جوش و سفارشات نهایی نشده"
              @click="loadStorageBoilingPointList"
              color="primary" text-color="white"
              class="text-left"/>
    </q-card-section>
    <q-card-actions :align="$q.screen.lt.md?'center':'right'" v-if="localItems && localItems.length>0"
                    class="no-padding q-mr-sm">
      <q-btn label="تایید" @click="upsertOrder" color="primary" icon="check" v-close-popup/>
      <q-btn flat label="انصراف" @click="cancelOrder" color="red" icon="cancel" v-close-popup/>
    </q-card-actions>
    <q-card-section class="no-padding q-mt-xs">
      <q-input v-model="additionalDescription"
               type="textarea"
               filled
               label="توضیحات تکمیلی"/>
    </q-card-section>
    <q-card-section class="no-padding q-mt-xs">
      <q-table
          :data="localItems"
          row-key="Table_IDD"
          hide-header
          flat
          wrap-cells>
        <template v-slot:body="props">
          <q-tr v-if="!$q.screen.lt.md" :props="props" class="my-class">
            <q-td class="no-padding">
              <q-chip @click="showProductDetailsDialog(props.row)"
                      clickable
                      color="red" text-color="white" square rounded :label="props.row.Goods_Code"/>
            </q-td>
            <q-td class="no-padding">{{ props.row.Goods_Name }}</q-td>
            <q-td class="no-padding" style="max-width: 150px">
              <q-field
                  v-model="props.row.selectedCount"
                  label="تعداد خرید"
                  label-color="indigo"
                  autofocus
                  filled
                  dir="ltr"
                  dense
                  clearable
                  :hint="`تعداد کارتن (${props.row.Goods_Box?Math.round(props.row.selectedCount/props.row.Goods_Box):0})`"
                  lazy-rules
                  :rules="[
                      val => val && val.toString().replaceAll(',','') !== '' || 'تعداد خرید را وارد نمایید',
                      val => parseInt(val.toString().replaceAll(',','')) >= 0   || 'تعداد خرید عددی بزرگتر صفر می باشد، لطفا اصلاح نمایید'
                  ]">
                <template v-slot:control="{ id, floatingLabel, value, emitValue }">
                  <input :id="id" class="q-field__native text-right" :value="value" type="number"
                         @change="e => emitValue(e.target.value)"
                         v-show="floatingLabel">
                </template>
                <template v-slot:append>
                  <q-badge color="brown" text-color="white" :label="props.row.Unit_Name"/>
                </template>
              </q-field>
            </q-td>
            <q-td>
              <q-field
                  v-if="!isBuyRequest"
                  v-model="props.row.BuyLast_Price"
                  mask="currency"
                  label="مبلغ خرید واحد"
                  label-color="indigo"
                  autofocus
                  dir="ltr"
                  dense
                  filled
                  clearable
                  lazy-rules
                  :rules="[
                      val => val.toString().replaceAll(',','') !== null && val.toString().replaceAll(',','') !== '' || 'مبلغ خرید را وارد نمایید',
                      val => parseInt(val.toString().replaceAll(',','')) >= 0   || 'مبلغ خرید عددی بزرگتر صفر می باشد، لطفا اصلاح نمایید'
                  ]">
                <template v-slot:control="{ id, floatingLabel, value, emitValue }">
                  <input :id="id" class="q-field__native text-right" :value="value"
                         @change="e => emitValue(e.target.value.replaceAll(',',''))"
                         v-money="moneyFormatForDirective"
                         v-show="floatingLabel">
                </template>
                <template v-slot:append>
                  <q-btn icon="attach_money" flat round padding="none" @click="updatePrice(props.row)"
                  >
                    <q-tooltip>
                      ثیت آخرین قیمت خرید
                    </q-tooltip>
                  </q-btn>
                </template>
              </q-field>
            </q-td>
            <td>
              <q-btn icon="delete" flat round color="red" @click="deleteGoods(props.row)"/>
            </td>
          </q-tr>
          <q-tr v-if="$q.screen.lt.md" :props="props" class="my-class">
            <q-card flat>
              <q-card-section class="no-padding">
                <q-btn size="sm" icon="delete" flat round color="red" @click="deleteGoods(props.row)"/>
                <q-chip size="sm" color="red" text-color="white" square rounded :label="props.row.Goods_Code"/>
                <span class="text-subtitle2">{{ props.row.Goods_Name }}</span>
              </q-card-section>
              <q-card-section horizontal class="q-gutter-xs">
                <q-field
                    filled
                    v-model="props.row.selectedCount"
                    label="تعداد خرید"
                    label-color="indigo"
                    autofocus
                    dir="ltr"
                    dense
                    clearable
                    lazy-rules
                    :rules="[
                      val => val.toString().replaceAll(',','') !== null && val.toString().replaceAll(',','') !== '' || 'تعداد خرید را وارد نمایید',
                      val => parseInt(val.toString().replaceAll(',','')) >= 0   || 'تعداد خرید عددی بزرگتر صفر می باشد، لطفا اصلاح نمایید'
                  ]">
                  <template v-slot:control="{ id, floatingLabel, value, emitValue }">
                    <input :id="id" class="q-field__native text-right" :value="value" type="number"
                           @change="e => emitValue(e.target.value)"
                           v-show="floatingLabel">
                  </template>
                  <template v-slot:append>
                    <q-badge color="brown" text-color="white" :label="props.row.Unit_Name"/>
                  </template>
                </q-field>
                <q-field

                    filled
                    v-model="props.row.BuyLast_Price"
                    mask="currency"
                    label="مبلغ خرید واحد"
                    label-color="indigo"
                    autofocus
                    dir="ltr"
                    dense
                    clearable
                    lazy-rules
                    :rules="[
                      val => val.toString().replaceAll(',','') !== null && val.toString().replaceAll(',','') !== '' || 'مبلغ خرید را وارد نمایید',
                      val => parseInt(val.toString().replaceAll(',','')) >= 0   || 'مبلغ خرید عددی بزرگتر صفر می باشد، لطفا اصلاح نمایید'
                  ]">
                  <template v-slot:control="{ id, floatingLabel, value, emitValue }">
                    <input :id="id" class="q-field__native text-right" :value="value"
                           @change="e => emitValue(e.target.value.replaceAll(',',''))"
                           v-money="moneyFormatForDirective"
                           v-show="floatingLabel">
                  </template>
                  <template v-slot:append>
                    <q-btn icon="attach_money" flat round padding="none" @click="updatePrice(props.row)"
                    >
                      <q-tooltip>
                        ثیت آخرین قیمت خرید
                      </q-tooltip>
                    </q-btn>
                  </template>
                </q-field>
                <q-separator/>
              </q-card-section>

            </q-card>

          </q-tr>
        </template>
      </q-table>
    </q-card-section>

    <q-dialog maximized v-model="StorageBoilingPointListDialog">
      <StorageBoilingPoint @selected-items="storageBoilingPointItemsSelected" :is-dialog="true" :is-apply="false"
                           :is-select-list="true"/>
    </q-dialog>

    <q-dialog
        :maximized="$q.screen.lt.md"
        v-model="showProductDetails">
      <ProductDetail :product="selectedProductDetails"/>
    </q-dialog>
  </q-card>
</template>

<script>
import {mapActions} from "vuex";
import StorageBoilingPoint from "@/components/products/StorageBoilingPoint.vue";
import ProductDetail from "@/components/productInfo/ProductDetail.vue";

export default {
  name: "BuyGoodsList",
  components: {ProductDetail, StorageBoilingPoint},
  props: {
    buyDescription: {
      type: String,
      default: () => undefined
    },
    buyNum: {
      type: Number,
      default: undefined
    },
    items: {
      type: Array,
      default: () => []
    },
    selectedCustomer: {
      type: Object
    },
    immediatelySaleCustomer: {
      type: Object,
      default: () => undefined
    },
    isBuyRequest: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      localItems: [],
      StorageBoilingPointListDialog: false,
      moneyFormatForDirective: {
        decimal: '.',
        thousands: ',',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: true
      },
      additionalDescription: undefined,
      selectedProductDetails: undefined,
      showProductDetails: false
    }
  },
  methods: {
    ...mapActions({
      Order: 'Buys/upsertOrder',
      getProductDetails: 'Products/getByID',
      getOrder: 'Buys/getOrder'
    }),
    showProductDetailsDialog(row) {
      this.getProductDetails(row.Goods_ID).then((res) => {
        this.selectedProductDetails = res[0];
        this.showProductDetails = true
      })
    },
    storageBoilingPointItemsSelected(args) {
      this.localItems = args
      this.StorageBoilingPointListDialog = false
    },
    loadStorageBoilingPointList() {
      this.StorageBoilingPointListDialog = true
    },
    deleteGoods(goodsInfo) {
      const founded = this.localItems.findIndex(item => item.Goods_ID === goodsInfo.Goods_ID)
      this.$delete(this.localItems, founded)
      this.$emit('goods-deleted', goodsInfo)
    },
    updatePrice(orderItemInfo) {
      orderItemInfo.BuyLast_Price = orderItemInfo.BuyDay_Price
    },
    cancelOrder() {
      this.localItems = []
      this.$emit('clear-items')
    },
    upsertOrder() {
      this.Order({
        BuyNum: this.buyNum ? this.buyNum : 'NULL',
        Buy_Kind: 1,
        Items: this.localItems,
        Cs_ID: this.selectedCustomer ? this.selectedCustomer.Cs_ID : undefined,
        Sale_Cs_ID: this.immediatelySaleCustomer ? this.immediatelySaleCustomer.Cs_ID : -1,
        Desc: this.additionalDescription
      }).then((res) => {
        if (res[0].BuyNum !== undefined) {
          this.$q.notify({
            type: 'positive',
            color: 'positive',
            position: 'top',
            message: `سفارش خرید به شماره ${res[0].BuyNum} ثبت گردید`
          })
          this.$emit('clear-items', [])
          if (this.selectedCustomer) {
            this.$router.push("/buy_order_trace").catch(() => {
            })
          } else {
            this.$router.push("/order-trace").catch(() => {
            })
          }
        } else {
          this.$q.notify({
            type: 'negative',
            color: 'negative',
            position: 'top',
            message: 'خطا در ثبت سفارش'
          })
        }
      })
    }
  },
  watch: {
    items: function (val) {
      val.forEach(rec => {
        const founded = this.localItems.find(item => item.Goods_ID === rec.Goods_ID)
        if (founded === undefined) {
          this.localItems.push(rec)
        }
      })
    }
  },
  created() {
    this.additionalDescription = this.buyDescription
    this.localItems = JSON.parse(JSON.stringify(this.items));
  }
}
</script>

<style scoped>

</style>